// src/utils/FileManagerUploadHelper.js


import { uploadChunkForFileManager, mergeFileManagerChunks } from "../Services/api";

class FileManagerUploadHelper {
  static GenerateHashId = async (input) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(input);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    return [...new Uint8Array(hashBuffer)]
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("")
      .slice(0, 32);
  };

  static GenerateUploadId(file) {
    return `${file.name}-${file.size}-${file.lastModified}-${new Date().getTime()}`;
  }

  static GenerateTempId = async (input) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(input);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    return [...new Uint8Array(hashBuffer)]
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("")
      .slice(0, 32);
  };
 static async UploadFileChunks({
    ExtraOptions = {},
    OnProgress,
    File,
  }) {
    const ChunkSize = 1 * 1024 * 1024;
    const TotalChunks = Math.ceil(File.size / ChunkSize);
    const UploadId = this.GenerateUploadId(File);
    
    for (let i = 0; i < TotalChunks; i++) {
      const Start = i * ChunkSize;
      const End = Math.min(Start + ChunkSize, File.size);
      const Chunk = File.slice(Start, End);
      const formData = new FormData();
      formData.append("File", Chunk);
      
      let isSuccess = false;
      for (let attempt = 0; attempt < 3 && !isSuccess; attempt++) {
        try {
          await uploadChunkForFileManager({
            UploadId,
            ChunkIndex: i,
            body: formData,
          });
          isSuccess = true;
        } catch (err) {
          await new Promise((res) => setTimeout(res, 300));
        }
      }
      if (!isSuccess) throw new Error(`Failed to upload chunk ${i}`);
      OnProgress?.(Math.floor(((i + 1) / TotalChunks) * 100));
    }

    await mergeFileManagerChunks({
      Id: ExtraOptions.ContractId,
      Source: null,
      FolderId: ExtraOptions.ParentId,
      UploadType: "Folder",
      TotalChunks,
      IsLast: true,
      FileName: File.name,
      UploadId,
    });
  }
  static async UploadFile({
    File,
    ExtraOptions = {},
    OnProgress,
  }) {
    const ChunkSize = 1 * 1024 * 1024;
    const TotalChunks = Math.ceil(File.size / ChunkSize);
    const UploadId = this.GenerateUploadId(File);
    const TempId = await this.GenerateHashId(`upload-${UploadId}`);
    
    for (let i = 0; i < TotalChunks; i++) {
      const Start = i * ChunkSize;
      const End = Math.min(Start + ChunkSize, File.size);
      const Chunk = File.slice(Start, End);
      
      const formData = new FormData();
      formData.append("chunk", Chunk); 
      formData.append("IsLast", i === TotalChunks - 1);
      // =====================================

      await uploadChunkForFileManager({
        UploadId,
        ChunkIndex: i,
        TempId, 
        body: formData,
      });

      OnProgress?.(Math.floor(((i + 1) / TotalChunks) * 100));
    }
    
    await mergeFileManagerChunks({
      Id: ExtraOptions.ContractId,
      Source: null,
      FolderId: ExtraOptions.ParentId,
      UploadType: "Folder",
      TotalChunks,
      IsLast: true,
      FileName: File.name,
      UploadId,
      TempId, 
    });
  }
 
  static async StartUploadQueue({
    Files,
    ExtraOptions = {},
    OnOverallProgress,
  }) {
    let totalUploaded = 0;
    for (const file of Files) {
      await this.UploadFile({
        File: file,
        ExtraOptions,
        OnProgress: (chunkProgress) => {},
      });
      totalUploaded++;
      OnOverallProgress?.(Math.floor((totalUploaded / Files.length) * 100));
    }
  }
}

export default FileManagerUploadHelper;